import React, { createContext, useState, useContext, useEffect } from 'react';
import apiService from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const validateSession = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }
      try {
        await apiService.validateToken();
        const currentUser = apiService.getCurrentUser();
        setUser(currentUser);
      } catch {
        apiService.logout();
      } finally {
        setLoading(false);
      }
    };
    validateSession();
  }, []);

  const login = async (email, password) => {
    try {
      const data = await apiService.login(email, password);
      setUser(data.user);
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error?.message || 'فشل تسجيل الدخول'
      };
    }
  };

  const logout = () => {
    apiService.logout();
    setUser(null);
  };

  const roleName = user?.role?.name;
  const isAdmin = roleName === 'Admin';
  const isAuditor = roleName === 'Auditor';
  const isSheikh = roleName === 'Sheikh';
  const hasAccess = isAdmin || isAuditor || isSheikh;

  const value = {
    user,
    login,
    logout,
    isAuthenticated: !!user,
    loading,
    canEdit: isAdmin,
    isAdmin,
    isAuditor,
    isSheikh,
    hasAccess,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
